import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Coaching = () => {
  return (
    <>
      <Helmet>
        <title>Coaching | Slávka Vavřinová</title>
        <meta
          name="description"
          content="Slávka Vavřinová jako lektorka ve výuce HTML/CSS, Figma a React. Zjistěte, jak se naučit programovat."
        />
        <link rel="canonical" href="https://www.slavkavav.cz/coaching" />
      </Helmet>{' '}
      <div className="main">
        <h2>Coaching</h2>
        <p>
          Do you want to create your own website? Check out{' '}
          <a
            className="link"
            href="https://www.czechitas.cz/"
            target="_blank"
            rel="noreferrer"
          >
            Czechitas
          </a>{' '}
          and explore numerous courses available to help you learn.
        </p>
        <p>Previously, I coached in courses like:</p>
        <ul>
          <li>
            <a
              className="link"
              href="https://www.czechitas.cz/kurzy/figma"
              target="_blank"
              rel="noreferrer"
            >
              Figma
            </a>
          </li>
          <li>
            <a
              className="link"
              href="https://www.czechitas.cz/kurzy/react-1"
              target="_blank"
              rel="noreferrer"
            >
              React 1
            </a>
          </li>
          <li>
            <a
              className="link"
              href="https://www.czechitas.cz/kurzy/uvod-do-html-a-css"
              target="_blank"
              rel="noreferrer"
            >
              Introduction to HTML and CSS
            </a>
          </li>
          <li>
            <a
              className="link"
              href="https://www.czechitas.cz/kurzy/stan-se-koderkou"
              target="_blank"
              rel="noreferrer"
            >
              Become a Coder
            </a>
            <Link to="/coaching/coder">
              <button className="button button--coaching">Enter</button>
            </Link>
          </li>
          <li>
            <a
              className="link"
              href="https://www.czechitas.cz/kurzy/bootstrap"
              target="_blank"
              rel="noreferrer"
            >
              Bootstrap
            </a>
          </li>
        </ul>
        <p>
          Currently, there is no branch in České Budějovice, and I am not
          actively coaching at the moment.
        </p>
      </div>
    </>
  );
};

export default Coaching;
